import posthog from "posthog-js";

export function initPostHog() {
  posthog.init('phc_q5WPE5fokP4vGxtgguyZYKdePHXH9n7ojtswNJd4PqcP', {
    api_host: 'https://us.i.posthog.com',
    defaults: '2026-05-30',

    autocapture: true, // 自动埋点
    capture_pageview: false, // 自动记录页面访问
    capture_pageleave: true, // 自动记录页面离开

    person_profiles: 'identified_only'// 登录后再创建 Person
  })

  posthog.register({
    platform: 'web',
    // env: process.env.VUE_APP_ENV || process.env.NODE_ENV
  })

}

export default posthog